<template>
  <div>
    <ion-item>
      <ion-label position="stacked" :color="validator.$error ? 'danger' : ''">
        <slot></slot>
        <ion-text v-if="required" color="danger">*</ion-text>
      </ion-label>
      <ion-input
        :required="required"
        :type="type"
        :value="inputValue"
        :color="validator.$error ? 'danger' : ''"
        :data-cy="dataCy"
        :id="id"
        :inputmode="inputmode"
        :maxlength="maxlength"
        @input="
          inputValue = $event.target.value.trim();
          $emit('input', inputValue);
        "
      ></ion-input>
    </ion-item>
    <ion-item
      v-for="(message, rule) in errors"
      v-bind:key="`rule-${rule}`"
      color="danger"
    >
      {{ message }}
    </ion-item>
  </div>
</template>

<script>
export default {
  props: {
    validator: {
      required: true,
      type: Object
    },
    errorMessages: {
      required: false,
      type: Object,
      default: () => {
        return {};
      }
    },
    required: {
      required: false,
      type: Boolean
    },
    type: {
      required: false,
      type: String,
      default: "text"
    },
    value: {
      required: false,
      default: ""
    },
    dataCy: {
      required: false,
      type: String,
      default: ""
    },
    id: {
      required: false,
      type: String,
      default: ""
    },
    inputmode: {
      required: false,
      type: String,
      default: ""
    },
    maxlength: {
      required: false,
      type: String,
      default: undefined
    }
  },

  data: function() {
    return {
      inputValue: this.value
    };
  },

  watch: {
    // this is necessary because we update this component sometimes and want the values overridden
    // this can happen when we have JS that fills in values - like the auto complete address
    value() {
      this.inputValue = this.value;
    }
  },

  computed: {
    errors() {
      let errors = {};

      Object.entries(this.errorMessages).forEach(([rule, message]) => {
        if (this.validator.$error && !this.validator[rule]) {
          errors[rule] = message;
        }
      });

      return errors;
    }
  }
};
</script>
